<template>
  <v-btn-toggle rounded>
    <v-btn :color="leftColor" x-small :ripple="false">
      {{ left }}
    </v-btn>
    <v-btn color="light" x-small :ripple="false">
      {{ right }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  props: {
    left: { type: String },
    leftColor: { type: String, default: "primary" },
    right: { type: String },
    rightColor: { type: String, default: "light" },
  },
};
</script>

<style></style>
